import React, { useEffect, useState } from "react";

export default function Offer() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Ads";

    fetch("https://lifetimedesign.in/LtcJsonAPI.asmx/DesignList?icid=350")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setOffers(data.data);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div className="spinner-border text-primary mb-3"></div>
        <h5>Please wait...</h5>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div className="container1">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">
                <i className="bi bi-house"></i> Home
              </a>
            </li>
            <li className="breadcrumb-item active">Ads</li>
          </ol>
        </nav>

        <div className="row">
          {offers.map((offer) => (
            <div className="col-md-6 mb-4" key={offer.id}>
              <img
                src={`https://lifetimedesign.in/controlpanel/Designs/${offer.image_url}`}
                alt={offer.code}
                className="img-fluid12 w-100"
                style={{
                  borderRadius: "8px",
                  display: "block",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f6f8fc, #eef2f7)",
    padding: "20px 15px",
  },
  loadingContainer: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};
